import HomeBaseComponent, { IHomeBaseProps, IHomeBaseState } from '../home/homePage/HomeBaseComponent';
import * as style from './style.css';
import { ITextIndexModel } from '../home/news/ITextIndexModel';
import { NewsRowComponent } from './NewsRowComponent';
// import { Helmet } from 'react-helmet';
import React = require('react');

interface IProps extends IHomeBaseProps {
    url: string

}

interface IState extends IHomeBaseState {
    models: ITextIndexModel[];
}

export default class PrivacyIndexPage extends HomeBaseComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            models: []
        };
    }

    protected getUriHomeData() {
        return this.props.url;
    }

    protected onDataChanged(data: ITextIndexModel[]) {
        this.setState({ models: data });
    }

    renderView() {
        return (
            <>
                {/* <Helmet>
                    <title>{this.props.metaTitle}</title>
                    <meta name="description" content={this.props.metaDescription} />
                </Helmet> */}
                <div className={style.newsWrapper}>
                    <h3>Aktualności</h3>
                    <div className={style.dataRows}>
                        {this.state.models.map((m, i) =>
                            <NewsRowComponent key={i} model={m} closeable={true} />)}
                    </div>
                </div>
            </>
        );
    }
}
